/**
 * @file index.js
 * @author fanyang06@baidu.com
 * @desc 业绩看板
 */

import bendsdk from '@baidu/bend-plugin-sdk';

const routes = [
    {
        path: '/performanceDashboard',
        name: 'performanceDashboard',
        meta: {auth: 'in'},
        component: () => import('./views/index.vue')
    }
];

// 如果有权限控制的话，这里得引入SDK判断权限是否可以调用本插件，或者重插件配置页面读取插件信息
export default class PerformanceDashboard extends bendsdk.plugin {
    /**
   * 在安装时配置路由
   *
   * @param router 路由实例
   */
    onInstall(router) {
        Array.prototype.push.apply(router.options.routes, routes);
        router.addRoutes(routes);
    }
}
